// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hex-poly.stroke[data-v-47ee9115]{stroke-width:2;stroke:#fff}", ""]);
// Exports
module.exports = exports;
